import { useEffect, useState } from "react";

const MOBILE_BREAKPOINT = 768;
const TABLET_BREAKPOINT = 991;

const getViewportState = (width) => ({
    width,
    isMobile: width <= MOBILE_BREAKPOINT,
    isTablet: width > MOBILE_BREAKPOINT && width <= TABLET_BREAKPOINT,
    isDesktop: width > TABLET_BREAKPOINT,
});

export const useView = () => {
    const [viewport, setViewport] = useState(() => {
        if (typeof window === "undefined") {
            return {
                width: 0,
                isMobile: false,
                isTablet: false,
                isDesktop: true,
            };
        }

        return getViewportState(window.innerWidth);
    });

    useEffect(() => {
        const handleResize = () => {
            setViewport(getViewportState(window.innerWidth));
        };

        handleResize();

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return viewport;
};